<template>
  <section class="lectures">
    <div class="box">
      <h3>สื่อประกอบการสอน</h3>
      <ul class="lectures-list">
        <span class="description">Image</span>
        <li data-v-3211a124 class="pass">
          <span data-v-3211a124 class="video-progress"></span>
          <i data-v-3211a124 class="lni lni-checkmark"></i>
          <p data-v-3211a124>Basic mathematical formulas</p>
          <span data-v-3211a124 class="description">IMG</span>
        </li>
        <li data-v-3211a124 class="pass">
          <span data-v-3211a124 class="video-progress"></span>
          <i data-v-3211a124 class="lni lni-checkmark"></i>
          <p data-v-3211a124>Basic mathematical formulas</p>
          <span data-v-3211a124 class="description">IMG</span>
        </li>
        <li data-v-3211a124 class="pass">
          <span data-v-3211a124 class="video-progress"></span>
          <i data-v-3211a124 class="lni lni-checkmark"></i>
          <p data-v-3211a124>Basic mathematical formulas</p>
          <span data-v-3211a124 class="description">IMG</span>
        </li>
      </ul>
      <ul class="lectures-list">
        <span class="description">PDF</span>
        <li data-v-3211a124 class="pass">
          <span data-v-3211a124 class="video-progress"></span>
          <i data-v-3211a124 class="lni lni-checkmark"></i>
          <p data-v-3211a124>Learning Documents</p>
          <span data-v-3211a124 class="description">PDF</span>
        </li>
        <li data-v-3211a124 class="pass">
          <span data-v-3211a124 class="video-progress"></span>
          <i data-v-3211a124 class="lni lni-checkmark"></i>
          <p data-v-3211a124>Learning Documents</p>
          <span data-v-3211a124 class="description">PDF</span>
        </li>
        <li data-v-3211a124 class="pass">
          <span data-v-3211a124 class="video-progress"></span>
          <i data-v-3211a124 class="lni lni-checkmark"></i>
          <p data-v-3211a124>Learning Documents</p>
          <span data-v-3211a124 class="description">PDF</span>
        </li>
      </ul>
      <ul class="lectures-list">
        <span class="description">Website</span>
        <li data-v-3211a124 class="pass">
          <span data-v-3211a124 class="video-progress"></span>
          <i data-v-3211a124 class="lni lni-minus"></i>
          <p data-v-3211a124>Google Search</p>
          <span data-v-3211a124 class="description">URL</span>
        </li>
        <li data-v-3211a124 class="pass">
          <span data-v-3211a124 class="video-progress"></span>
          <i data-v-3211a124 class="lni lni-minus"></i>
          <p data-v-3211a124>Google Search</p>
          <span data-v-3211a124 class="description">URL</span>
        </li>
        <li data-v-3211a124 class="pass">
          <span data-v-3211a124 class="video-progress"></span>
          <i data-v-3211a124 class="lni lni-minus"></i>
          <p data-v-3211a124>Google Search</p>
          <span data-v-3211a124 class="description">URL</span>
        </li>
      </ul>
      <br />
    </div>
  </section>
</template>
<script>
import { mapState } from "vuex";

export default {
  name: "LectureList",
  computed: {
    ...mapState({
      sections: state => state.sections
    }),
    courseId() {
      return this.$store.getters.courseId;
    },
    learningLecture() {
      return this.$store.getters.learningLecture;
    },
    currentDisplayIds() {
      return this.$store.getters.currentDisplayIds;
    }
  },
  mounted() {
    this.$store.commit("initCourseIdAndToken", {
      token: this.$cookies.get("user_token"),
      // courseId: this.$route.query.courseId
      courseId: this.$route.params.id
    });
    this.fetchSections();
  },
  methods: {
    fetchSections() {
      this.$store.dispatch("fetchSections", this.courseId);
    },
    selectLecture(section, lecture, canSelect) {
      if (!canSelect) {
        return;
      }
      this.$store.dispatch("changeDisplay", {
        idcourse: this.courseId,
        idsection: section._id,
        idlecture: lecture._id,
        lecture
      });
    },
    displayType(lecture) {
      return lecture.type;
    },
    videoWatchedStyle(lecture) {
      if (lecture.type === "VDO") {
        const history = this.learningLecture[lecture._id];
        if (history && history.videoCurrentTime > 0) {
          const percent = (history.videoCurrentTime * 100) / history.videoTime;
          return {
            width: `${percent}%`
          };
        }
      }
      return {};
    },
    liPermission(lecture, lectures) {
      if (lecture.type === "VDO") {
        const videoIds = lectures.filter(l => l.type === "VDO").map(l => l._id);
        const currentLectureIndex = videoIds.indexOf(lecture._id);
        const previousLectureIndex = currentLectureIndex - 1;
        if (previousLectureIndex > 0) {
          if (
            this.$store.getters.videoPermission(
              lecture._id,
              videoIds[previousLectureIndex]
            )
          ) {
            return true;
          } else {
            return false;
          }
        } else {
          return true;
        }
      } else if (lecture.type === "EXAM") {
        return this.$store.getters.examPermission(lectures, lecture._id);
      }
      return true;
    },
    liClassName(lecture, lectures) {
      let className = "";
      className += this.liPermission(lecture, lectures) ? "pass" : "lock";
      className +=
        this.currentDisplayIds.indexOf(lecture._id) > -1 ? " current" : "";
      return className;
    },
    finishedLectureIconName(lecture, lectures) {
      if (this.liPermission(lecture, lectures)) {
        if (this.learningLecture[lecture._id]) {
          if (this.learningLecture[lecture._id].percent === 100) {
            return "lni lni-checkmark";
          }
        }
        return "lni lni-minus";
      }
      return "lni lni-lock-alt";
    },
    goToDetail(item) {
      this.$router.push({
        name: "course_detail",
        params: {
          id: this.courseId
        }
      });
    }
  }
};
</script>
<style scoped>
.v-application p {
  margin-bottom: 0px;
}
</style>